module.exports = __webpack_public_path__ + "static/media/team-robin-lisa.d62133c6.jpg";